import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  Grid,
  Hidden,
  withStyles,
  Paper /* , IconButton */,
} from '@material-ui/core'
import TemplateHtml from './TemplateHtml'
import language from 'utils/vast-languagepack'

import MultiExpansionPanels from 'components/MultiExpansionPanels'
import General from './General/General'
import Snippets from './Snippets/Snippets'
import { last } from 'lodash'
import SMS from 'components/AddOrEditTaskPage/Preview/SMS'
import { toggleDefaultValuesModal } from 'actions/template'
// import { CodeBraces } from 'mdi-material-ui'

const Panels = connect(
  state => ({
    sectionSelectedBool:
      typeof state.email.sectionSelected === 'number' ||
      typeof state.email.sectionSelected === 'string',
  }),
  null,
)(({ sectionSelectedBool, emailCardSelected }) => {
  const arr =
    emailCardSelected === 'sms'
      ? [
          {
            title: 'GENERAL',
            component: <General emailCardSelected={emailCardSelected} />,
            toolTip:
              language.templatePage.templateFormPage.toolTips.generalToolTips,
            open: true,
          },
        ]
      : [
          {
            title: 'GENERAL',
            component: <General />,
            toolTip:
              language.templatePage.templateFormPage.toolTips.generalToolTips,
            open: true,
          },
          {
            title: 'SNIPPETS',
            component: <Snippets />,
            toolTip:
              language.templatePage.templateFormPage.toolTips.snippetToolTips,
            open: true,
          },
        ]

  return (
    <>     
        <MultiExpansionPanels arr={arr} />     
    </>
  )
})

export const DndEditor = ({ classes, modal }) => <TemplateHtml modal={modal} />

const Desktop = ({
  classes,
  modal,
  emailCardSelected,
  toggleDefaultValuesModal,
}) => {
  const left = (
    <Grid className={classes.left} item md={8} lg={8} xl={8}>
      <Paper className={classes.email}>
        {emailCardSelected === 'sms' ? (
          <>
            <SMS />
            {/* <div style={{ position: 'absolute', top: 10, right: 10 }}>
              <IconButton
                onClick={() => toggleDefaultValuesModal(true)}
                style={{ color: '#014c94' }}
              >
                <CodeBraces />
              </IconButton>
            </div> */}
          </>
        ) : (
          <DndEditor modal={modal} />
        )}
      </Paper>
    </Grid>
  )

  const right = (
    <Grid className={classes.right} item md={4} lg={4} xl={4}>
      <Panels emailCardSelected={emailCardSelected} />
    </Grid>
  )

  return (
    <Hidden smDown>
      <Grid style={{ height: '100%', paddingTop: 24 }} container spacing={24}>
        {left}
        {right}
      </Grid>
    </Hidden>
  )
}

const styles = theme => ({
  left: {
    // height: 'calc(100% + 52px)',
    // minWidth: 707,
    // maxWidth: 707,
    // width: 707,
    // [theme.breakpoints.down('md')]: {
    // 	// width: 'auto',
    // 	// minWidth: 0,
    // },
  },
  right: {
    height: 'calc(100vh - 163px)',
    overflowY: 'auto',
    // minWidth: 'calc(100vw - 1263px)',
    // [theme.breakpoints.down('md')]: {
    // 	minWidth: 'auto',
    // },
    // [theme.breakpoints.up('xl')]: {
    // 	minWidth: 'auto',
    // },
  },
  email: {
    border: '1px solid #adadad',
    // padding: '10px 0 20px',
    borderRadius: 35,
    // height: '100%',
    // backgroundColor: '#014c94',
    overflow: 'hidden',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      borderRadius: 0,
      border: 'none',
      boxShadow: 'none',
      backgroundColor: 'transparent',
      height: 'calc(100% - 56px)',
    },
  },
  splitFormPreviewPaper: {
    border: '1px solid #adadad',
    padding: 20,
    borderRadius: 35,
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      height: 'calc(100% - 56px)',
    },
  },
  emailHeaderText: {
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
    },
  },
  emailScroll: {
    height: '97%',
    [theme.breakpoints.down('sm')]: {
      height: '100%',
    },
  },
})

export default connect(
  state => ({ emailCardSelected: last(state.email.cardSelected) }),
  dispatch => bindActionCreators({ toggleDefaultValuesModal }, dispatch),
)(withStyles(styles)(Desktop))
